export default "__VITE_ASSET__D6Gy2oPN__"